import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private _mobileNavOpen = signal(false);

  public mobileNavOpen = this._mobileNavOpen.asReadonly();  

  public toggleMobileSideMenu(): void {
    this._mobileNavOpen.set(!this._mobileNavOpen());
  }

  public closeMobileSideMenu(): void {  
    this._mobileNavOpen.set(false);
  }
} 